import React, { Component } from "react";
import styled from "styled-components";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Box, Col, Row, Text, Img } from "../../comps";
import { Theme } from "../../theme/theme-provider";

import { miniWindowLogo } from "../../theme/image";
import { faChevronRight, faInfo } from "@fortawesome/free-solid-svg-icons";
import { playerDemoGif } from "../../theme/uploaded";

const Wrapper = styled(Row)`
  width: 100%;
  min-width: 600px;
  margin-top: 30px;
  padding: 20px 20px;
  justify-content: space-between;
  align-items: center;
  /* box-shadow: 0 4px 12px 0 rgba(0, 0, 0, 0.6); */
`;

const Details = styled(Col)`
  width: 50%;
`;

const VideoWrapper = styled(Box)`
  width: ${({ width }) => width};
  height: ${({ height }) => height};
  box-shadow: 0 4px 16px 0 rgba(0, 0, 0, 0.6);
`;

const Head = styled(Row)`
  align-items: center;
  border-bottom: 1px solid ${({ theme }) => theme.color.BLUE_5};
`;

const TextContainer = styled(Row)`
  margin-top: 3px;
  padding: 0px 10px;
  align-items: center;
  color: ${({ theme }) => theme.textColor.light};
`;

const ListItem = ({ icon, text }) => {
  return (
    <TextContainer>
      {icon && (
        <FontAwesomeIcon
          style={{
            fontSize: "20px",
            color: Theme.textColor.light,
            margin: "5px",
          }}
          icon={icon}
        />
      )}
      <Text
        fontFamily={Theme.fontFamily.grenze}
        fontWeight={500}
        color={Theme.textColor.light}
        fontSize="24px"
        textAlign="left"
        marginLeft="8px"
      >
        {text}
      </Text>
    </TextContainer>
  );
};

export default () => {
  const videoWidth = 400;
  const videoHeight = (9 * videoWidth) / 16;
  return (
    <Wrapper>
      {/* <VideoWrapper width={videoWidth + "px"} height={videoHeight + "px"}>
        <Video videoId="ioNng23DkIM" />
      </VideoWrapper> */}
      <Img height="80%" src={playerDemoGif} />
      <Details>
        <Col>
          <Head>
            <Text
              marginLeft="10px"
              fontFamily={Theme.fontFamily.grenze}
              fontWeight={600}
              fontSize="32px"
              color={Theme.color.BLUE_5}
              textAlign="left"
            >
              {"Player & Mini Window"}
            </Text>
            <Img
              style={{ marginLeft: "8px" }}
              src={miniWindowLogo}
              width="20px"
              height="20px"
            />
          </Head>
          <ListItem
            text="Keyboard controls are enabled as well. Go to /config to see player controls"
            icon={faChevronRight}
          />
          <ListItem
            text="With mini mode, you can continue with your stuff while watching the videos. Checkout demo to know more"
            icon={faChevronRight}
          />
          <ListItem
            text="Window will stay on top only if you are using desktop app"
            icon={faInfo}
          />
        </Col>
      </Details>
    </Wrapper>
  );
};
